import { useEffect, useState, useRef } from "react";
import SearchIcon from "../../assets/searchIcon.svg";
import PreinitiateModal from "./preInitiateModal/PreinitiateModal";
import DeactivateOrDeleteCase from "./DeactivateOrDeleteCase";
import CaseStageUpdateConfirmation from "./caseStageUpdateConfirmation";
import CustomPagination from "../../utils/paginationUtils";
import { CaseServices } from "../../services/CaseServices";
import { ReportServices } from "../../services/ReportServices";
import { NotificationServices } from "../../services/NotificationServices";
import { HospitalServices } from "../../services/HospitalServices";
import { InterUserMangementServices } from "../../services/InternalUserMangementServices";
import AssignUserToCase from "./assignUserToCase/AssignUserToCase";
import "./caseList.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../config/user";
import {
  updateMember,
  updatePageNumber,
  updateStatus,
  updateSubStatus,
  updateSelectedHospital,
  updateSelectedIsTpa,
} from "../../redux/caseDetailsSlice";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import CaseFilters from "./caseListParts/CaseFilters";
import CaseTableToolbar from "./caseListParts/CaseTableToolbar";
import CaseTable from "./caseListParts/CaseTable";
import { toast } from "react-toastify";

const CaseListV2 = ({
  caseId,
  selectedStage,
  getStageCaseReport,
  getStageColor,
  assignedTo,
  assignedFilter,
  handleGetAllCasesClick,
  getDataCheck,
  isFromClaimCases,
  setPending,
}) => {
  const [cases, setCases] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalFilteredCases, setTotalFilteredCases] = useState(0);
  const [filteredUnassignedCases, setFilteredUnassignedCasesd] = useState(0);
  const [users, setUsers] = useState(null);
  const [stageTimeColor, setStageTimeColor] = useState(null);
  const {
    pageNo,
    member,
    status,
    subStatus,
    selectedHospitalId,
    selectedIsTpa,
  } = useSelector((state) => state.caseDetails);
  const [currentCommandCenterStage, setCurrentCommandCenterStage] =
    useState(null);
  const [page, setPage] = useState(pageNo ? pageNo : 1);
  const [isLoading, setIsLoading] = useState(true);

  const [caseStatus, setCaseStatus] = useState(status ? status : "");
  const [nextStepUser, setNextStepUser] = useState(member ? member : "");
  const [commandCenterStage, setCommandCenterStage] = useState(
    subStatus ? subStatus : "",
  );
  const [searchKey, setSearchKey] = useState("");
  const [searchPmjayId, setSearchPmjayId] = useState("");
  const [isPreinitiateOpen, setPreinitiateOpen] = useState(false);
  const [hospitalList, setHospitalList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [subStatusList, setSubStatusList] = useState([]);
  const [teamUserList, setTeamUserList] = useState([]);
  const [caseType, setCaseType] = useState("");
  const [isTpa, setIsTpa] = useState(
    selectedIsTpa === 0 || selectedIsTpa === 1 ? selectedIsTpa : "",
  );
  const [teamUserId, setTeamUserId] = useState(assignedTo ? assignedTo : "");
  const [hospitalId, setHospitalId] = useState(
    Array.isArray(selectedHospitalId) ? selectedHospitalId : [],
  );
  const [openConfirmationPopup, setConfirmationPopup] = useState(false);
  const [updateStageMethodName, setUpdateStageMethodName] = useState({
    method: "",
    case: "",
  });
  const [newPmjayId, setNewPmjayId] = useState({
    pmjayId: "",
    caseId: "",
  });
  const [selectedCase, setSelectedCase] = useState(null);
  const [showRecordings, setShowRecordings] = useState(null);
  const [showDeactivateModal, setShowDeactvateModal] = useState(null);
  const [assignUser, setAssignUser] = useState(null);
  const outsideUser = useSelector((state) => state.currentRole.isOutsideUser);
  const storeCaseId = useSelector((state) => state.caseDetails.caseId);
  const [limit, setLimit] = useState(10);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hasInitialized = useRef(false);
  let searchTimeRef = useRef();
  const user = getUser();
  const statusList = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const caseAssignMessage = () => {
    window.alert("To perform any actions please assign the case.");
  };
  async function getAllCasesCount() {
    try {
      const hospitalIds =
        hospitalId && hospitalId?.map((hospital) => hospital.id);
      let res = commandCenterStage
        ? await CaseServices.unassignedCaseCount(
            searchKey,
            searchPmjayId,
            page,
            limit,
            assignedFilter,
            caseType,
            caseStatus,
            caseId,
            hospitalIds,
            nextStepUser,
            commandCenterStage,
            teamUserId,
            undefined,
            isTpa,
          )
        : await CaseServices.unassignedCaseCount(
            searchKey,
            searchPmjayId,
            page,
            limit,
            assignedFilter,
            caseType,
            caseStatus,
            caseId,
            hospitalIds,
            nextStepUser,
            "",
            teamUserId,
            selectedStage,
            isTpa,
          );
      setFilteredUnassignedCasesd(res?.data?.filteredUnassignedCases);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  }
  async function AllCases() {
    if (!getDataCheck) return;
    try {
      setIsLoading(true);
      setPending && setPending(true);
      const hospitalIds = hospitalId?.map((item) => item.value);
      let res = commandCenterStage
        ? await CaseServices.allCasesBeta(
            searchKey,
            searchPmjayId,
            page,
            limit,
            assignedFilter,
            caseType,
            caseStatus,
            caseId,
            hospitalIds,
            nextStepUser,
            commandCenterStage,
            teamUserId,
            undefined,
            isTpa,
          )
        : await CaseServices.allCasesBeta(
            searchKey,
            searchPmjayId,
            page,
            limit,
            assignedFilter,
            caseType,
            caseStatus,
            caseId,
            hospitalIds,
            nextStepUser,
            "",
            teamUserId,
            selectedStage,
            isTpa,
          );
      setCases(res?.data?.caseList);
      setTotalPages(res?.data?.totalPages);
      // await getAllCasesCount();
      getAllCasesCount().catch(handleApiErrorResponses);
      // setFilteredUnassignedCasesd(res?.data?.filteredUnassignedCases);
      setTotalFilteredCases(res?.data?.totalFilteredCases);
      setIsLoading(false);
      setPending && setPending(false);
    } catch (error) {
      handleApiErrorResponses(error);
      setIsLoading(false);
      setPending && setPending(false);
    }
  }
  const getUsersDetails = async () => {
    try {
      const response = await ReportServices.getUsers();
      setUsers(response.data.users);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleSearch = (e) => {
    //debouncing structure
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
    setPage(1);
  };
  const handleSearchPmjayId = (e) => {
    //debouncing structure
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchPmjayId(e.target.value);
      setPage(1);
    }, 500);
  };
  const handleRemoveFilters = async () => {
    setNextStepUser("");
    setCaseStatus("");
    setCommandCenterStage("");
    setHospitalId([]);
    !assignedTo && setTeamUserId("");
    setCaseType("");
    setIsTpa("");
  };

  const getHospitalList = async () => {
    try {
      const response = await HospitalServices.gethospitals("", 1, 1500);

      setHospitalList(response.data.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getRoleList = async () => {
    try {
      const response = await NotificationServices.getRoleList();
      setRoleList(response?.data?.allRoles);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getSubStatusList = async () => {
    try {
      const response = await NotificationServices.getSubMasterStages(
        200,
        "",
        1,
        "",
      );
      setSubStatusList(response?.data?.subMasterStages);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getTeamUsers = async () => {
    try {
      const response = await InterUserMangementServices.getTeamUser(100, 1, "", 1);
      setTeamUserList(response.data.teamUsers);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getDefaultStageTimeColor = async () => {
    try {
      const response = await ReportServices.getDefaultStageTimeColor();
      setStageTimeColor(response.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    if (!getDataCheck) return;
    const timer = setTimeout(() => {
      getDataCheck && AllCases(); //this is done to stop the calling of the function on initial mount
    }, 300);

    return () => clearTimeout(timer);
  }, [
    page,
    limit,
    searchKey,
    hospitalId,
    caseStatus,
    nextStepUser,
    commandCenterStage,
    // storeCaseId,
    selectedStage,
    teamUserId,
    caseType,
    isTpa,
    assignedFilter,
    getDataCheck,
    searchPmjayId,
  ]);

  useEffect(() => {
    const init = async () => {
      if (hasInitialized?.current) return;
      hasInitialized.current = true;
      await Promise.all([
        getHospitalList(),
        getRoleList(),
        getSubStatusList(),
        getDefaultStageTimeColor(),
        getUsersDetails(),
        getTeamUsers(),
      ]);
    };
    init();
  }, []);
  useEffect(() => {
    dispatch(updateMember(nextStepUser));
  }, [nextStepUser, dispatch]);
  useEffect(() => {
    dispatch(updateStatus(caseStatus));
  }, [caseStatus, dispatch]);
  useEffect(() => {
    dispatch(updateSubStatus(commandCenterStage));
  }, [commandCenterStage, dispatch]);
  useEffect(() => {
    dispatch(updateSelectedHospital(hospitalId));
  }, [hospitalId, dispatch]);
  useEffect(() => {
    dispatch(updateSelectedIsTpa(isTpa));
  }, [isTpa, dispatch]);
  useEffect(() => {
    dispatch(updatePageNumber(page));
  }, [page, dispatch]);
  //This useEffect is used to handle when someone selects the cards to see details in that case we need to reset page number to 1
  // useEffect(() => {
  //   setPage(pageNo);
  // }, [pageNo]);

  return (
    <div className="case-list-container">
      {getDataCheck && (
        <CaseFilters //comment
          roleList={roleList}
          nextStepUser={nextStepUser}
          setNextStepUser={(value) => {
            setPage(1);
            setNextStepUser(value);
          }}
          statusList={statusList}
          caseStatus={caseStatus}
          setCaseStatus={(value) => {
            setPage(1);
            setCaseStatus(value);
          }}
          subStatusList={subStatusList}
          commandCenterStage={commandCenterStage}
          setCommandCenterStage={(value) => {
            setPage(1);
            setCommandCenterStage(value);
          }}
          hospitalList={hospitalList}
          hospitalId={hospitalId}
          setHospitalId={(value) => {
            setPage(1);
            setHospitalId(value);
          }}
          teamUserList={teamUserList}
          teamUserId={teamUserId}
          setTeamUserId={(value) => {
            setPage(1);
            setTeamUserId(value);
          }}
          assignedTo={assignedTo}
          caseType={caseType}
          setCaseType={(value) => {
            setPage(1);
            setCaseType(value);
          }}
          isTpa={isTpa}
          setIsTpa={(value) => {
            setPage(1);
            setIsTpa(value);
          }}
          handleRemoveFilters={handleRemoveFilters}
          isFromClaimCases={isFromClaimCases}
          handleSearchPmjayId={handleSearchPmjayId}
          SearchIcon={SearchIcon}
        />
      )}
      <CaseTableToolbar
        assignedFilter={assignedFilter}
        filteredUnassignedCases={filteredUnassignedCases}
        totalFilteredCases={totalFilteredCases}
        SearchIcon={SearchIcon}
        handleSearch={handleSearch}
        setLimit={setLimit}
        limit={limit}
        AllCases={AllCases}
        handleGetAllCasesClick={handleGetAllCasesClick}
        getDataCheck={getDataCheck}
      />

      {getDataCheck && (
        <>
          {" "}
          <CaseTable
            cases={cases}
            isLoading={isLoading}
            users={users}
            stageTimeColor={stageTimeColor}
            setAssignUser={setAssignUser}
            user={user}
            setConfirmationPopup={setConfirmationPopup}
            setUpdateStageMethodName={setUpdateStageMethodName}
            setSelectedCase={setSelectedCase}
            setPreinitiateOpen={setPreinitiateOpen}
            setCurrentCommandCenterStage={setCurrentCommandCenterStage}
            showRecordings={showRecordings}
            setShowRecordings={setShowRecordings}
            outsideUser={outsideUser}
            navigate={navigate}
            assignedFilter={assignedFilter}
            filteredUnassignedCases={filteredUnassignedCases}
            totalFilteredCases={totalFilteredCases}
            caseAssignMessage={caseAssignMessage}
            getStageCaseReport={getStageCaseReport}
            setShowDeactvateModal={setShowDeactvateModal}
            AllCases={AllCases}
          />
          <div className="list-pagination">
            <CustomPagination
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          </div>
        </>
      )}

      {isPreinitiateOpen && (
        <div>
          <PreinitiateModal
            selectedCase={selectedCase}
            isOpen={setPreinitiateOpen}
            subStatusList={subStatusList}
            AllCases={AllCases}
            currentCommandCenterStage={currentCommandCenterStage}
          />
        </div>
      )}
      {showDeactivateModal && (
        <div>
          <DeactivateOrDeleteCase
            selectedCase={selectedCase}
            setOpen={setShowDeactvateModal}
          />
        </div>
      )}
      {openConfirmationPopup && (
        <CaseStageUpdateConfirmation
          setConfirmationPopup={setConfirmationPopup}
          updateStageMethodName={updateStageMethodName}
          AllCases={AllCases}
          getStageCaseReport={getStageCaseReport}
        />
      )}
      {assignUser && (
        <AssignUserToCase
          commandCenterStage={assignUser.commandCenterStage}
          commandCenterStageId={assignUser.commandCenterStageId}
          isOpen={setAssignUser}
          AllCases={AllCases}
          reAssign={assignUser.reAssign}
        />
      )}
    </div>
  );
};

export default CaseListV2;
